<app-card class="select-patient-card" label="People in Your Care" *ngIf="hasProxies() && !hasActiveProxy">
    <div class="patients-row" *ngFor="let proxyRow of proxyRows">
        <div class="patient-card" *ngFor="let proxy of proxyRow">
            <img src="/assets/images/icons/SVG/icon-user-pic.svg" alt="User icon"/>
            <h1>{{proxy.firstName}} {{proxy.lastName}}</h1>
            <dx-button class="button" text="View Patient Portal" (onClick)="changeProxy(proxy.toCtcaUniqueId)"></dx-button>
        </div>
    </div>
</app-card>